import {
  CONTENT_FETCH_SUCCESS,
  CONTENT_FETCH_FAIL,
  CONTENT_FETCH_BY_ID_SUCCESS,
  CONTENT_FETCH_BY_ID_FAIL,
  CONTENT_SET_DRAFT
} from '../constant/actionType';
import logger from '../util/logger';

export const initialState = {
  content: [],
  contentDraft: {},
  contentStore: {},
  isContentFailed: false,
  isContentLoaded: false,
  isFailed: false,
  isLoaded: false,
  paging: {}
};

const contentReducer = (state = initialState, { type, data }) => {
  switch (type) {
    case CONTENT_SET_DRAFT: {
      logger.debug(`${CONTENT_SET_DRAFT}: ${JSON.stringify(data)}`);

      const { content } = data;

      return {
        ...state,
        contentDraft: content
      };
    }

    case CONTENT_FETCH_SUCCESS: {
      logger.debug(`${CONTENT_FETCH_SUCCESS}: ${JSON.stringify(data)}`);

      const { content, paging } = data;

      return {
        ...state,
        content,
        isFailed: false,
        isLoaded: true,
        paging
      };
    }

    case CONTENT_FETCH_FAIL: {
      logger.debug(`${CONTENT_FETCH_FAIL}`);

      return { ...state, isFaled: true, isLoaded: true };
    }

    case CONTENT_FETCH_BY_ID_SUCCESS: {
      logger.debug(`${CONTENT_FETCH_BY_ID_SUCCESS}: ${JSON.stringify(data)}`);

      const { content } = data;
      const { _id } = content;

      const contentStore = {
        ...state.contentStore,
        [_id]: content
      };

      return {
        ...state,
        contentStore: { ...contentStore },
        isContentFailed: false,
        isContentLoaded: true
      };
    }

    case CONTENT_FETCH_BY_ID_FAIL: {
      logger.debug(`${CONTENT_FETCH_BY_ID_FAIL}`);

      return { ...state, isContentFailed: true, isContentLoaded: true };
    }

    default:
      return state;
  }
};

export default contentReducer;
